/*
 * Artink page hero: the background video plays only while the hero is on screen (and not
 * with reduced motion), a toggle pauses it, and blank-link buttons scroll to the next section.
 */

function bootHero(root) {
  if (!root || root.dataset.pheroBooted === '1') return;
  root.dataset.pheroBooted = '1';

  const controller = new AbortController();
  const { signal } = controller;
  const video = root.querySelector('[data-phero-video]');
  const toggle = root.querySelector('[data-phero-toggle]');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // The visitor's choice wins over automatic play/pause.
  let userPaused = reduce;
  let io;

  const setToggle = (playing) => {
    if (!toggle) return;
    toggle.classList.toggle('is-paused', !playing);
    toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
  };

  const play = () => {
    if (!video) return;
    video
      .play()
      .then(() => {
        video.classList.add('is-playing');
        setToggle(true);
      })
      .catch(() => setToggle(false));
  };

  if (video) {
    setToggle(!userPaused);
    if (window.IntersectionObserver) {
      io = new IntersectionObserver(
        ([entry]) => {
          if (entry?.isIntersecting && !userPaused) play();
          else video.pause();
        },
        { threshold: 0.15 }
      );
      io.observe(root);
    } else if (!userPaused) {
      play();
    }

    toggle?.addEventListener(
      'click',
      () => {
        if (video.paused) {
          userPaused = false;
          play();
        } else {
          userPaused = true;
          video.pause();
          setToggle(false);
        }
      },
      { signal }
    );
  }

  // Blank-link buttons and the scroll cue move to the section after the hero.
  root.addEventListener(
    'click',
    (event) => {
      const link = event.target instanceof Element ? event.target.closest('[data-phero-next]') : null;
      if (!link) return;
      const section = root.closest('.shopify-section');
      const next = section?.nextElementSibling;
      if (!next) return;
      event.preventDefault();
      next.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      // Move focus along with the scroll for keyboard users.
      const heading = next.querySelector('h1, h2');
      if (heading instanceof HTMLElement) {
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
      }
    },
    { signal }
  );

  root._artinkHeroCleanup = () => {
    controller.abort();
    io?.disconnect();
    video?.pause();
    root.dataset.pheroBooted = '0';
  };
}

function initAll(scope = document) {
  scope.querySelectorAll('[data-artink-page-hero]').forEach(bootHero);
}

initAll();
document.addEventListener('shopify:section:load', (event) => initAll(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-artink-page-hero]').forEach((root) => root._artinkHeroCleanup?.());
});
